import moment from 'moment'
import React, { Component } from 'react'
export default class IDCardFrontViewMob extends Component {
  constructor(props) {
    super(props)
    this.state = {
      network: this.props.network,
      digitalcarddata: this.props.data,
      planinfo: this.props.data.memberIdCardList[0].planInfo,
      plainId: this.props.data.memberIdCardList[0].planId,
      prefix: '',
      groupno: '',
      contactno: this.props.contactNumber,
      //   day:moment(this.props.data.memberIdCardList[0].enrollmentDate).format('DD'),
      //   month:moment(this.props.data.memberIdCardList[0].enrollmentDate).format('MM'),
      //   year:moment(this.props.data.memberIdCardList[0].enrollmentDate).format('YYYY'),
      membersince: '',
      isAdvancedHT: this.props.data && (this.props.data.memberIdCardList[0].planId=="10051" || this.props.data.memberIdCardList[0].planId=="10052" || this.props.data.memberIdCardList[0].planId=="10053" ||
      this.props.data.memberIdCardList[0].planId=="10061" || this.props.data.memberIdCardList[0].planId=="10062" || this.props.data.memberIdCardList[0].planId=="10063" ),
      //    + this.state.day+this.state.year,
    }
    this.printparentcall = this.printparentcall.bind(this)
    console.log('MOB FRONT PROPS++', this.props)
  }

  componentDidMount() {
    this.dateformat()
    console.log('FIND PREFIX DARA', this.props.data.memberIdCardList[0].planInfo)
    this.state.planinfo.map((data, index) => {
      if (data.idcardField == 'prefix') {
        this.setState({ prefix: data.fieldValue })
      }
      if (data.idcardField == 'group') {
        this.setState({ groupno: data.fieldValue })
      }
      if (data.idcardField == 'contact number') {
        this.setState({ contactno: data.fieldValue })
      }
    })
  }

  dateformat() {
    var day = moment(this.props.data.memberIdCardList[0].enrollmentDate).format('DD')
    var mon = moment(this.props.data.memberIdCardList[0].enrollmentDate).format('MM')
    var year = moment(this.props.data.memberIdCardList[0].enrollmentDate).format('YYYY')
    var date = mon + '/' + day + '/' + year
    this.setState({ membersince: date })
  }

  printparentcall() {
    this.props.printCardView()
  }
  render() {
    return (
      <div class="fview">
        <div class="fv_background_image">
          {/* =============Top Imaghe container========= */}
          <div class="fv_top_image_container">
            <img src={require('../../Images/NewIcons/logo.png')} class="fv_left_logo img-fluid" />
            { !this.state.isAdvancedHT ?
              <h3 style={{ textDecoration: "underline", color: "rgb(47, 49, 146)", fontSize: 14, margin: "10px 38px -8px", fontWeight: 600 }}>Health Tools:</h3> 
              :<div style={{marginTop:13, marginRight:42}}>
                  <div class="fv_ht_healthtools_name" style={{fontFamily:"Anton", color:"#f14950"}}>ADVANCED</div>
                  <div class="fv_ht_healthtools_name" style={{fontFamily:"Anton", fontSize:19, marginTop:-8}}>Health Tools</div>
                </div>}
          </div>

          <div class="fv_card ">
            {/* =============ledt container========= */}
            <div class="fv_left_container">
              <div class="fv_ht_username">
              {`${this.props.data.memberIdCardList[0].prefix || ""} ${this.props.data.memberIdCardList[0].firstName} ${this.props.data.memberIdCardList[0].middleName || ""} ${this.props.data.memberIdCardList[0].lastName} ${this.props.data.memberIdCardList[0].suffix || ""}`}
              </div>

              {/* {
                  this.state.digitalcarddata && this.state.digitalcarddata.memberIdCardList.map((data,index)=>

                    <div>
                      {
                        index==0
                        ? <div>
                        <div class="fv_adult_top_name">{data.firstName} {data.lastName}</div>
                        <div class="fv_username">
                        {this.state.prefix}{this.props.showEmpId ? data.empId : data.memberId}
                        </div>
                      </div>
                        :
                        null
                      }
                    </div>
                  )
                } */}

                {this.props.network == "senior65" ?
                 <div class="fv_ht_group_fieldname">
                  {this.state.prefix + this.props.data.memberIdCardList[0].memberId}
                  </div>
                 :
                <div class="mob_scrollbarview">
                <div class="fv_list_view">
                  <div class="fv_ht_group_fieldname">Member ID</div>
                  <div class="fv_ht_group_fieldname">
                    {/* {this.state.prefix}{this.props.showEmpId ? this.props.data.memberIdCardList[0].empId : this.props.data.memberIdCardList[0].memberId}  */}
                    {localStorage.getItem('SOURCE') === 'NEO' || this.state.plainId == "10051" || this.state.plainId == "10052" || this.state.plainId == "10053"  || this.state.plainId == "10061" || this.state.plainId == "10062" || this.state.plainId == "10063"? (
                      this.state.prefix+this.props.data.memberIdCardList[0].memberId
                    ) : (
                      <>
                        {this.state.prefix}
                        {this.props.data.memberIdCardList[0].empId}
                      </>
                    )}
                  </div>
                </div>

                <div class="fv_list_view">
                  <div class="fv_ht_group_fieldname">Group ID</div>
                  <div class="fv_ht_group_fieldname">{this.state.groupno}</div>
                </div>

                {/* {
                   this.state.digitalcarddata && this.state.digitalcarddata.memberIdCardList.map((data,index)=>
                   <div>
                     {
                        index != 0
                        ?

                      <div class="fv_list_view">
                         <div class="fv_list_adultname">{data.firstName} {data.lastName}</div>
                         <div class="fv_list_username">{this.state.prefix}{this.props.showEmpId ? data.empId : data.memberId}</div>
                      </div>
                        :null
                     }
                   </div>
                   )
                } */}
              </div>}
            </div>

            {/* =============Right Conrtainer========= */}
            <div class="fv_right_container">
              <div class="mb-3">
                <div class="fv_ht_right_heading">To Access Your {this.state.isAdvancedHT?"Advanced ":""}Health Tools,</div>
                <div class="fv_ht_right_heading">Use These Contact Numbers:</div>
              </div>
              <hr style={{
                marginTop: '-9px',
                marginBottom: '6px',
                border: 0,
                borderTop: '1px solid red',
              }} />

              {/* <div class="fv_joined_text">Program Details</div> */}

              {/* <div class="fv_right_table1">
                    <div class="fv_left_table">
                      <div class="fv_table_left_text">Member since</div>
                      <div class="fv_table_left_text">Group No.</div>
                      <div class="fv_table_left_text">Program ID</div>
                    </div>
                    <div class="fv_right_table">
                      <div class="fv_table_right_text">{this.state.membersince}</div>
                      <div class="fv_table_right_text">{this.state.groupno}</div>
                      <div class="fv_table_right_text">{this.state.digitalcarddata.memberIdCardList[0].planId}</div>
                    </div>
                  </div> */}

              {/* <div class="fv_space_2table"></div> */}

              {/* {this.props.network =='Smartshare' ? (
                    <div class="fv_table_middle_text">Sharing for all medical services is limited to $27,500/- per Member/per year</div>
                  ) : (
                    <div class="fv_space_2table"></div>
                  )} */}

              {/* ====================Dyanmic content for all user========== */}

              <div>
                {carddata.rightdata.map(data => (
                  <div>
                    <div class="fv_right_new_table">
                      <div class="fv_new_table_left_text">{data.fieldname}</div>
                      <div class="fv_new_table_right_text">{data.fieldvalue}</div>
                    </div>
                  </div>
                ))}
                 {this.state.isAdvancedHT && <div>
                          <div class="fv_right_new_table">
                            <div class="fv_new_table_left_text">On-Demand Care</div>
                            <div class="fv_new_table_right_text">866-697-8212</div>
                          </div>
                          <div class="web_fv_right_new_table">
                            <div class="fv_new_table_left_text">Concierge Service</div>
                            <div class="fv_new_table_right_text">888-636-7119</div>
                          </div>
                          </div>}
              </div>
            </div>
          </div>
          {/* =============Bttom  comntavt container========= */}

          
          {
            !this.props.isAdvancedHT ?
              <div
                class="fv_ht_bottom_center_text "
                style={{ marginTop: "10%", padding: '12px', marginLeft: '0' }}
              >
                <span class="fv_ht_bold_text">
                  Universal HealthShare programs from Universal Health Fellowship are health care cost sharing ministry programs, not insurance. For Member confirmations and questions, call UHF Member Support at {this.props.contactNumber}.
                </span>
              </div>
              :
              <div class="fv_ht_bottom_center_text">
                This program is <span class="fv_ht_bold_text">NOT INSURANCE COVERAGE</span> and does not meet the minimum creditable coverage
                requirements under the Affordable Care Act or Massachusetts M.G.L. c. 111M and 956 CMR 5.00.
              </div>
          }
          {/* {(() => {
                switch ( this.props.network) {
                  case 'PHCS':
                    return (
                      <div class="fv_center_details_text">
                      Universal HealthShare plans from Universal Health Fellowship are health care cost sharing ministry programs, not insurance. We are IN NETWORK for Multiplan/PHCS Practitioner & Ancillary Network. Providers & Members confirmations and questions {this.props.contactNumber}
                  </div>
                    )

                  case 'Smartshare':
                    return (
                      <div class="fv_center_details_text">
                      Universal HealthShare plans from Universal Health Fellowship are health care cost sharing ministry programs, not insurance. We are IN NETWORK for Multiplan/PHCS Practitioner & Ancillary Network. Providers & Members confirmations and questions {this.props.contactNumber}
                  </div>
                    )

                  case 'AFMC':
                    return (
                      <div class="fv_center_details_text">
                      Universal HealthShare plans from Universal Health Fellowship are health care cost sharing ministry programs,
not insurance. We are IN NETWORK for The Arizona Foundation for physician and ancillary services. Providers & Members confirmations and questions {this.props.contactNumber}
                  </div>
                    )
                }
              })()} */}
        </div>

        {/* <div class="fv_bottom">card-bottoom</div> */}
      </div>
    )
  }
}

const carddata = {
  name: 'Avishkar Patil',
  leftdata: [
    {
      fieldname: 'Member ID',
      fieldvalue: 101
    },
    {
      fieldname: 'Group ID',
      fieldvalue: 102
    }
  ],

  rightdata: [
    {
      fieldname: 'Aetna Dental',
      fieldvalue: '855-647-6764'
    },
    {
      fieldname: 'Coast to Coast Vision',
      fieldvalue: '855-647-6764'
    },
    {
      fieldname: 'FlexCare EAP',
      fieldvalue: '866-697-8212'
    }
  ]
}
